import { Box, Grid, Paper, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PersonalCompanyInformationForm from "views/User/OnBoard/Company/PersonalCompanyInformationForm";
import VerificationCompanyForm from "views/User/OnBoard/Company/VerificationCompanyForm";
import ProgressOnboard from "views/User/OnBoard/ProgressOnboard";
import BillingParticipantForm from "views/User/OnBoard/Company/BillingCompanyForm";
import AgreementForm from "views/User/OnBoard/Company/CompanyAgreementForm";
import AppColor from "utilities/AppColor";
import { useDispatch } from "react-redux";
import { showToast } from "store/slices/toast";
// import AppButton from "components/CustomButtons/AppButton";
import AppConfig, { PART_TYPE_COMPANY } from "config/AppConfig";
import { fetchCompanyCreateByAdmin } from "store/slices/company";
import md5 from "md5";
import { fetchCompanyFeedback } from "store/slices/company";
import { fetchCompanyDetail } from "store/slices/company";
import AppDialog from "components/Dialog/AppDialog";
import ComponentLoading from "components/Common/ComponentLoading";
// import AppConfirmDialog from "components/Dialog/AppConfirmDialog";
import { fetchUpdateCompanyPersonalInfo } from "store/slices/company";
import AppUtil from "utilities/AppUtil";
import { fetchCompanyUpdateVerification } from "store/slices/company";
import { fetchCompanyUpdateAgreement } from "store/slices/company";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { fetchCompanyUpdateBillingInfo } from "store/slices/company";
import AdminFeedbackForm from "views/User/OnBoard/AdminFeedbackForm";
// import { fetchVerifyCompany } from "store/slices/company";
import PropTypes from "prop-types";
import OnboardSuccess from "../OnboardSuccess";
import { updateUserInfoSidebar } from "store/slices/auth";
import { logout } from "store/slices/auth";
import ScrollableTabs from "components/CustomTabs/AppTabsScroll";

const stripePromise = loadStripe(
  `${process.env.REACT_APP_CLIENT_STRIPE}`
);

const { APPROVAL_STATUS } = AppConfig;

const companyOnboard = [
  {
    label: "title.generalInformation",
    checked: false,
    code: PART_TYPE_COMPANY.GENERAL_INFO,
  },
  {
    label: "title.verification",
    checked: false,
    code: PART_TYPE_COMPANY.VERIFICATION,
  },
  {
    label: "title.billingInformation",
    checked: false,
    code: PART_TYPE_COMPANY.BILLING_INFO,
  },
  {
    label: "title.agreement",
    code: PART_TYPE_COMPANY.AGREEMENT,
    checked: false,
    isAgreement: true,
  },
];

const OnBoardCompany = (props) => {
  const { authInfo } = props;
  const { t } = useTranslation();
  const isMobile = AppUtil.mobileAndTabletCheck();
  const styles = makeStyles(() => ({
    container: {
      padding: "1rem",
    },
    wrapper: {
      padding: "1rem",
      border: "1px solid #d2d2d2",
    },
    wrapperLeft: {
      padding: "0 1rem 1rem 1rem",
      marginRight: "1rem",
      border: "1px solid #d2d2d2",
    },
    custom: {
      boxShadow: 0,
      '& .MuiPaper': {
        '& .MuiPaper-elevation': {
          boxShadow: '0px'
        }
      }
    },
    wrapperBottom: {
      // padding: "0 1rem 1rem 1rem",
      marginBottom: "1rem",
      border: isMobile ? '0px' : "1px solid #d2d2d2",
    },
    wrapperRight: {
      padding: "1rem",
      border: "1px solid #d2d2d2",
    },
    boxActive: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "2rem 0.5rem",
    },
    title: {
      display: "flex",
      marginBottom: "1rem",
      "& h5": {
        color: AppColor.mainColor,
      },
    },
  }));
  const classes = styles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [progressPercent, setProgressPercent] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [showOnboardSuccess, setShowOnboardSuccess] = useState(false);
  const [progress, setProgress] = useState([]);
  const [companyDetail, setCompanyDetail] = useState({});
  const [companyFeedback, setCompanyFeedback] = useState([]);
  const [isWaitingApproval, setIsWaitingApproval] = useState(false);
  const [partTypeCompany, setPartTypeCompany] = useState();

  const { company = {} } = companyDetail;

  const { approvalStatus } = company;
  const hostname = window.location.hostname;

  // const { role } = companyUser;

  const { id: companyId } = company;

  useEffect(() => {
    if (authInfo.companyId) {
      loadCompanyDetail();
    }
    // initProgressByCompanyType();
  }, [authInfo]);

  useEffect(() => {
    const listDomainSuperAdmin = process.env.REACT_APP_DOMAIN_SUPER_ADMIN.split(',');
    if (authInfo && authInfo.approvalStatus === APPROVAL_STATUS.ACTIVE && companyDetail && companyDetail.company && companyDetail.companyUser && listDomainSuperAdmin.indexOf(hostname) >= 0) {
      const port = window.location.port;
      dispatch(logout());
      window.open(`${window.location.protocol}//${companyDetail.company.domain}${port && port !== '' ? ':' + port : ''}/auth/company/login?email=${companyDetail.companyUser.email}`, '_self');
    }
  }, [authInfo, hostname, companyDetail.companyUser, companyDetail.company]);

  useEffect(() => {
    switch (currentStep) {
      case 0:
        setPartTypeCompany(PART_TYPE_COMPANY.GENERAL_INFO);
        break;
      case 1:
        setPartTypeCompany(PART_TYPE_COMPANY.VERIFICATION);
        break;
      case 2:
        setPartTypeCompany(PART_TYPE_COMPANY.BILLING_INFO);
        break;
      case 3:
        setPartTypeCompany(PART_TYPE_COMPANY.AGREEMENT);
        break;
      default:
        setPartTypeCompany(PART_TYPE_COMPANY.GENERAL_INFO);
        break;
    }
  }, [currentStep]);

  const loadCompanyDetail = async () => {
    const result = await dispatch(fetchCompanyDetail({ companyId: authInfo.companyId }));
    if (result.payload) {
      const { company: companyInfo } = result.payload;
      initProgressByCompanyType(companyInfo.approvalStatus);
      if (
        companyInfo.approvalStatus === APPROVAL_STATUS.REJECT
      ) {
        loadCompanyFeedback(companyInfo.id);
        setIsWaitingApproval(true);
      } else {
        setIsWaitingApproval(false);
      }
      setCompanyDetail({ ...result.payload });
      await dispatch(updateUserInfoSidebar({
        organizationName: '',
        firstName: result.payload.companyUser.firstName,
        lastName: result.payload.companyUser.lastName
      }));
    }
  };

  const loadCompanyFeedback = async () => {
    const result = await dispatch(
      fetchCompanyFeedback({ companyId: authInfo.companyId })
    );
    if (result.payload) {
      setCompanyFeedback([...result.payload]);
    }
  };

  const submitGeneralInfo = async (form) => {
    let params;
    let contentData;
    let fileLogo;
    setLoading(true);
    let result;
    if (companyId) {
      contentData = {
        companyId: companyId,
        companyInfo: {
          organizationName: form.organizationName.trim().replace(/  +/g, ' '),
          address1: form.address1,
          address2: form.address2,
          email: form.emailCompany.trim(),
          postalCode: form.postalCode,
          phone: form.phone,
          domain: form.domain,
          lat: form.lat,
          lng: form.lng,
          abn: form.abn,
        },
        companyUser: {
          // emailUser: form.email,
          firstName: form.firstName,
          lastName: form.lastName,
        },
        isShowRateForStaff: form.isShowRateForStaff
      };
      fileLogo = form.logo;
      params = {
        fileLogo: fileLogo,
        contentData: contentData,
        hostname: form.domain,
        approvalStatus: authInfo.approvalStatus
      };

      // check update domain
      if (form.domain !== company.domain) {
        params.isUpdateDomain = true;
      }
      result = await dispatch(fetchUpdateCompanyPersonalInfo(params));
    } else {
      contentData = {
        emailUser: form.email.trim(),
        passwordHash: md5(form.password),
        firstName: form.firstName,
        lastName: form.lastName,

        organizationName: form.organizationName.trim().replace(/  +/g, ' '),
        address1: form.address1,
        address2: form.address2,
        email: form.emailCompany.trim(),
        postalCode: form.postalCode,
        phone: form.phone,
        domain: form.domain,
        lat: form.lat,
        lng: form.lng,
        abn: form.abn,
        isShowRateForStaff: form.isShowRateForStaff
      };
      fileLogo = form.logo;
      params = {
        fileLogo: fileLogo,
        contentData: contentData,
      };
      result = await dispatch(fetchCompanyCreateByAdmin(params));
    }
    setLoading(false);
    if (result.payload) {
      if (!params.isUpdateDomain || authInfo.approvalStatus === APPROVAL_STATUS.PENDING) {
        loadCompanyDetail();
        AppUtil.scrollToTopById("main-panel");
        handleCheckProgress(0);
      }
    }
  };

  const submitVerification = async (form) => {
    setLoading(true);
    const result = await dispatch(fetchCompanyUpdateVerification(form));
    setLoading(false);
    if (result.payload) {
      loadCompanyDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(1);
    }
  };

  const submitBillingParticipant = async (form) => {
    setLoading(true);
    const result = await dispatch(fetchCompanyUpdateBillingInfo(form));
    setLoading(false);
    if (result.payload) {
      loadCompanyDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(2);
    }
  };

  const submitAgreement = async (form) => {
    const unCheckForm = progress.find(
      (item) => !item.checked && !item.isAgreement
    );

    if (unCheckForm) {
      dispatch(
        showToast({
          type: "warning",
          message: t(`toast.warning.needCompleteAllForm`),
        })
      );
      return;
    }
    setLoading(true);
    const result = await dispatch(
      fetchCompanyUpdateAgreement({
        ...form,
        id: companyId,
      })
    );
    setLoading(false);
    if (result.payload) {
      loadCompanyDetail();
      AppUtil.scrollToTopById("main-panel");
      if (approvalStatus === APPROVAL_STATUS.PENDING) {
        setShowOnboardSuccess(true);
      }
    }
  };

  const handleCheckProgress = (index) => {
    if (index + 1 === progress.length) {
      return;
    }
    setCurrentStep(index + 1);
  };

  const handleProgressStatus = (index, isCheck) => {
    let clone;
    clone = [...progress];
    if (clone[index]) {
      clone[index].checked = isCheck;
      setProgress(clone);

      if (approvalStatus === APPROVAL_STATUS.PENDING && isCheck && clone.filter((item) => item.checked === false)[0]) {
        handleCheckProgress(index);
      }
    }
    let percent = clone.filter((item) => item.checked);
    const numberFormComplete = percent.length;
    const numberForm = clone.length;
    setProgressPercent(parseInt((numberFormComplete / numberForm) * 100, 10));
  };

  const handleBackStep = (index) => {
    AppUtil.scrollToTopById("main-panel");
    if (
      companyDetail.company.approvalStatus === APPROVAL_STATUS.PENDING &&
      index > currentStep
    ) {
      if (progress[currentStep].checked) {
        for (let i = currentStep; i <= index; i++) {
          if (!progress[i].checked) {
            setCurrentStep(i);
            return;
          }
        }
        setCurrentStep(index);
      } else {
        dispatch(
          showToast({
            type: "warning",
            message: t(`toast.warning.needCompleteForm`),
          })
        );
      }
      return;
    }
    setCurrentStep(index);
  };

  const initProgressByCompanyType = (status) => {
    if (status === APPROVAL_STATUS.ACTIVE) {
      const companyOnboardActive = companyOnboard.filter(element => {
        return element.code !== PART_TYPE_COMPANY.AGREEMENT;
      });
      setProgress(companyOnboardActive);
    } else {
      setProgress(companyOnboard);
    }
  };

  const tabs = [
    {
      id: 1,
      title: t("title.generalInformation"),
      component: PersonalCompanyInformationForm
    },
    {
      id: 2,
      title: t("title.verification"),
      component: VerificationCompanyForm
    },
    {
      id: 3,
      title: t("title.billingInformation"),
      component: BillingParticipantForm
    },
    {
      id: 4,
      title: t("title.agreement"),
      component: AgreementForm
    },
  ];

  const handleChangeTab = index => {
    setCurrentStep(index);
  }

  return (
    <Box>
      {showOnboardSuccess ? (
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={12} md={12}>
            <Paper className={classes.wrapper}>
              <OnboardSuccess isCompany={true} />
            </Paper>
          </Grid>
        </Grid>
      ) : (
        <React.Fragment>
          {approvalStatus && approvalStatus !== APPROVAL_STATUS.ACTIVE &&
            <Typography style={{
              color: (approvalStatus === APPROVAL_STATUS.PENDING || approvalStatus === APPROVAL_STATUS.WAITING_FOR_APPROVAL) ?
                "#FA801F" : '#FF0000', marginBottom: '20px', textAlign: 'left'
            }}>
              {approvalStatus === APPROVAL_STATUS.PENDING ?
                t('text.company_pending')
                : approvalStatus === APPROVAL_STATUS.WAITING_FOR_APPROVAL ?
                  t('text.company_waiting_for_approval')
                  : t('text.company_reject')
              }
            </Typography>}
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={6} md={8}>
              {isMobile ?
                <React.Fragment>
                  {progress && progress.length > 0 && (
                    <ScrollableTabs
                    swipeable={false}
                    onChangeTab={handleChangeTab}
                    activeTab={currentStep}
                    tabs={tabs.filter((item) => {
                      if (approvalStatus !== APPROVAL_STATUS.ACTIVE) {
                        return item;
                      } else {
                        if (item.id !== 4) {
                          return item;
                        }
                      }
                    }).map(item => {
                      const {
                        title,
                        component: Component
                      } = item;
                      return {
                        tabLabel: title,
                        tabContent: currentStep === 2 ?
                          <Elements stripe={stripePromise}>
                            <Component
                              onSubmit={
                                currentStep === 0 ?
                                  submitGeneralInfo
                                  : currentStep === 1 ?
                                    submitVerification
                                    : currentStep === 2 ?
                                      submitBillingParticipant
                                      : submitAgreement
                              }
                              display={currentStep}
                              companyDetail={companyDetail}
                              changeProgressStatus={handleProgressStatus}
                              hideLeftControl={true}
                            />
                          </Elements>
                          :
                          <Elements stripe={stripePromise}>
                            <Component
                              onSubmit={
                                currentStep === 0 ?
                                  submitGeneralInfo
                                  : currentStep === 1 ?
                                    submitVerification
                                    : currentStep === 2 ?
                                      submitBillingParticipant
                                      : submitAgreement
                              }
                              display={currentStep}
                              companyDetail={companyDetail}
                              changeProgressStatus={handleProgressStatus}
                              hideLeftControl={true}

                            />
                          </Elements>
                      }
                    })
                    }
                  />
                  )}
                </React.Fragment>
                : <Paper className={classes.wrapperLeft}>
                  {progress && progress.length > 0 && (
                    <React.Fragment>
                      <PersonalCompanyInformationForm
                        onSubmit={submitGeneralInfo}
                        changeProgressStatus={handleProgressStatus}
                        display={currentStep === 0}
                        companyDetail={companyDetail}
                        hideLeftControl={true}
                      // disabled={isWaitingApproval}
                      />
                      <VerificationCompanyForm
                        onSubmit={submitVerification}
                        changeProgressStatus={handleProgressStatus}
                        companyDetail={companyDetail}
                        display={currentStep === 1}
                        hideLeftControl={true}
                      // disabled={isWaitingApproval}
                      />
                      <Elements stripe={stripePromise}>
                        <BillingParticipantForm
                          onSubmit={submitBillingParticipant}
                          changeProgressStatus={handleProgressStatus}
                          companyDetail={companyDetail}
                          display={currentStep === 2}
                          hideLeftControl={true}
                        // disabled={isWaitingApproval}
                        />
                      </Elements>
                      <AgreementForm
                        onSubmit={submitAgreement}
                        changeProgressStatus={handleProgressStatus}
                        companyDetail={companyDetail}
                        display={currentStep === 3}
                        // disabled={isWaitingApproval}
                        hideLeftControl={true}
                      />
                      {
                        companyFeedback.filter(item => item.partTypeCompany === partTypeCompany)[0] &&
                        (
                          <React.Fragment>
                            <hr />
                            <AdminFeedbackForm
                              isCompany={true}
                              display={isWaitingApproval}
                              feedback={companyFeedback.filter(item => item.partTypeCompany === partTypeCompany)[0]}
                            />
                          </React.Fragment>
                        )
                      }
                    </React.Fragment>
                  )}
                </Paper>}

            </Grid>
            {!isMobile && <Grid item xs={12} sm={6} md={4}>
              <Paper className={classes.wrapperRight}>
                <ProgressOnboard
                  step={currentStep}
                  value={progressPercent}
                  progress={progress}
                  handleBackStep={handleBackStep}
                  feedbacks={
                    isWaitingApproval &&
                    companyFeedback.map((item) => {
                      item["partType"] = item.partTypeCompany;
                      return item;
                    })
                  }
                />
              </Paper>
            </Grid>}
          </Grid>
        </React.Fragment>
      )}
      <AppDialog
        open={loading}
        onClose={() => setLoading(false)}
        noTitle
        noCloseButton
        disableEscapeKeyDown
      >
        <Box my={3}>
          <ComponentLoading />
        </Box>
      </AppDialog>
    </Box>
  );
};
OnBoardCompany.propTypes = {
  authInfo: PropTypes.object,
};
export default OnBoardCompany;